import React from 'react';
import { Paginator } from '@weezevent/nacre';

import Styles from './moderationPaginator.module.css';

export default function ModerationPaginator({ currentPage, setCurrentPage, totalCount, pageSize }) {
    return (
        <div className={Styles['moderation-paginator']}>
            <Paginator
                currentPage={currentPage}
                onPageChange={numberPage => {
                    setCurrentPage(numberPage);
                }}
                totalCount={totalCount}
                pageSize={pageSize}
            />
        </div>
    );
}
